import React, { useEffect } from 'react';

import { type BackgroundFormData } from 'src/store/newJmrPageSlice/types';
import { CaseSources } from 'src/utils/jmrUtils';

import AustinButton from './austinButton';

interface GeneralUserOptionProps {
  handleChange: (key: keyof BackgroundFormData, value: any) => void;
  backgroundFormData: BackgroundFormData;
}

const GeneralUserOption = ({ handleChange, backgroundFormData }: GeneralUserOptionProps) => {
  useEffect(() => handleChange('caseSource', CaseSources.Austin), []);
  return <AustinButton caseSource={backgroundFormData.caseSource}></AustinButton>;
};

export default GeneralUserOption;
